module.exports = __webpack_public_path__ + "static/media/placeholder-image_16x9_Generic_400x255.6b6f7f4f.svg";